import { ProductOutlined, SearchOutlined } from "@ant-design/icons";
import { Col, Layout, Row } from "antd";
import { useRef, useState } from "react";
import FavoriteAdsIndex from "./Pages/Ads/FavoriteAdsIndex";
import FavoriteSearchsIndex from "./Pages/Searchs/FavoriteSearchsInd";
import ResponsiveMenu from "apps/Common/ResponsiveMenu";
import { Helmet } from "react-helmet-async";

const FavoriteIndex = () => {
  const containerRef = useRef(null);
  const { Sider, Content } = Layout;
  const [selectedKey, setSelectedKey] = useState<any>("ads");
  const items = [
    {
      key: "ads",
      label: "Favori İlanlarım",
      icon: <ProductOutlined />,
    },
    {
      key: "searchs",
      label: "Favori Aramalar",
      icon: <SearchOutlined />,
    },
  ];

  return (
    <Col span={24} className="!p-0">
      <Helmet>
                    <title className="capitalize">{"Favorilerim"}</title>
                  </Helmet>
      <Row
         gutter={[
          { xs: 10, md:10 , xl:20 }, 
          { xs:10 , md: 15, xl:20}   
        ]}
        className="xl:!h-screen !bg-white"
        ref={containerRef}
      >
        <Col xs={24} xl={6} xxl={4} className="!rounded-lg ">
          <ResponsiveMenu
            containerRef={containerRef}
            currentStep={selectedKey}
            setCurrentStep={setSelectedKey}
            defaultSelectedKeys={["0"]}
            menuItems={items}
            onClick={(e) => setSelectedKey(e.key)}
          />
        </Col>
        <Col xs={24} xl={18} xxl={20} className="  ">
          <Content className="!bg-white md:!p-4">
            {(() => {
              if (selectedKey === "ads") {
                return (
                  <>
                    <FavoriteAdsIndex />
                  </>
                );
              } else if (selectedKey === "searchs") {
                return (
                  <>
                    <FavoriteSearchsIndex />
                  </>
                );
              } 

              return <></>;
            })()}
          </Content>
        </Col>
      </Row>
    </Col>
  );
};

export default FavoriteIndex;
